import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AndroidDownload from "../pages/download/android/page";
import IosDownload from "../pages/download/ios/page";
import PcDownload from "../pages/download/pc/page";
import DocsPage from "../pages/docs/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/download/android",
    element: <AndroidDownload />,
  },
  {
    path: "/download/ios",
    element: <IosDownload />,
  },
  {
    path: "/download/pc",
    element: <PcDownload />,
  },
  {
    path: "/docs",
    element: <DocsPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;